module.exports = __webpack_public_path__ + "img/facebook.f29e9fe1.svg";